import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { GiCheckMark } from "react-icons/gi";
import Quotes from "../components/Landing/Quotes";
import Services from "../components/Services";

const ServiceAreas = () => {
  return (
    <>
      <div className="border-b-2">
        <Navbar />
      </div>
      <main className="w-full bg-gray-50">
        <div className="space-y-6 px-[5%] py-[7%] lg:p-[5%] ">
          <h1 className="text-center text-shadow text-3xl md:text-4xl font-bold text-gray-800 tracking-wider sub-headers">
            Area's of Service
          </h1>
          <div className="space-y-5">
            <p className="leading-relaxed tracking-wide  text-[#66666]">
              Total Exterior Cleaning is a{" "}
              <span className="font-bold">family run business</span> operating
              out of the Sutherland Shire area and covering St George, Eastern
              Suburbs, Northern Illawara Region and Surrounding areas. We
              believe when it comes to house washing nothing beats experience
              and quality equipment.{" "}
            </p>
            <p className="leading-relaxed tracking-wide text-[#66666]">
              See what a difference{" "}
              <span className="text-cyan-400">house washing </span> and{" "}
              <span className="text-cyan-400">high pressure cleaning </span> can
              make to your home.
            </p>
            <h2 className="font-extrabold text-lg">
              Areas Total Exterior Cleaning is Currently Servicing:
            </h2>
            <div>
              <ul className="grid grid-cols-2 md:grid-cols-3 mb-10">
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Illawong</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Menai</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Alfords Point</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Sutherland</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Kirrawee</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Gymea</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Gymea Bay</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Loftus</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Grays Point</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Miranda</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Barden Ridge</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Kareela</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Bangor</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Engadine</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Cronulla</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Como</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Kurnell</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Grays Point</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Bonnet Bay</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Lugarno</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Oatley</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">San Souci</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Ramsgate</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Taren Point</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Lilli Pilli</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Bexley North</p>
                </li>

                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Bexley</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Blakehurst</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Padstow</p>
                </li>
                <li className="flex space-x-2 items-center">
                  <GiCheckMark className="text-cyan-400" />
                  <p className="text-cyan-400">Eastern Suburbs</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <div className="mb-6">
        <Services />
      </div>
      <Quotes />
      <Footer />
    </>
  );
};

export default ServiceAreas;
